/** Line-type detectors for bot message blocks. */
export function isListItem(trimmed) {
  return trimmed.startsWith('•') || trimmed.startsWith('-');
}

export function listItemText(trimmed) {
  return trimmed.replace(/^[-•]\s*/, '');
}

export function isRelatedSectionHeader(trimmed) {
  return /^Shih edhe:/i.test(trimmed);
}

export function isSourceLine(trimmed) {
  return trimmed.startsWith('📄 Burimi:') || trimmed.startsWith('📄 Burimi :');
}

export function sourceLineText(trimmed) {
  return trimmed.replace(/^📄\s*Burimi:?\s*/i, 'Burimi: ');
}

export function isLinkOnlyLine(trimmed) {
  return trimmed.startsWith('🔗');
}

export function isNumberedStep(trimmed) {
  return /^\d+\./.test(trimmed);
}

export function numberedStepParts(trimmed) {
  const num = trimmed.match(/^(\d+)\./)[1];
  const body = trimmed.replace(/^\d+\.\s*/, '');
  return { num, body };
}

/** Parse "Shih edhe" follow-up lines: • title then 🔗 url */
export function parseRelatedLine(trimmed, relatedBuffer) {
  const bulletMatch = trimmed.match(/^[-•]\s*(.+)/);
  if (bulletMatch) {
    return { type: 'title', title: bulletMatch[1].replace(/\*\*/g, '').trim() };
  }

  const linkLine = trimmed.match(/^🔗\s*(https?:\/\/[^\s]+|www\.[^\s]+)/i);
  const urlOnly = trimmed.match(/^(https?:\/\/[^\s]+|www\.[^\s]+)/i);
  const urlFromLine = linkLine || urlOnly;
  if (urlFromLine) {
    return { type: 'url', url: urlFromLine[1] || urlFromLine[0] };
  }

  if (!trimmed) return { type: 'blank' };
  return { type: 'end' };
}
